<template>
  <div class="groupfollower-box">
    <div class="groupfollower-title1">Tutors</div>
    <div class="groupfollower-title2">People who care about you recently</div>
    <div class="member-list-box">
      <div
        class="member-content"
        v-for="(item, index) in memberList"
        :key="index"
      >
        <img :src="item.covey_user ? item.covey_user.photo : ''" />
        <el-tooltip
          effect="light"
          :content="item.covey_user ? item.covey_user.realname : ''"
          placement="bottom-start"
        >
          <div class="member-name">
            {{ item.covey_user ? item.covey_user.realname : "" }}
          </div>
        </el-tooltip>
        <div class="member-course">{{ item.nums }}&nbsp;courses</div>
      </div>
    </div>
    <div v-if="isMoreMembers" class="view-more">
      <el-button @click.stop="loadMoreGroupMemberList"
        >VIEW MORE FOLLOWERS</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      memberList: [],
      isMoreMembers: false,
      pageMemberParams: {
        limit: 12,
        page: 1,
      },
    };
  },
  mounted() {
    this.getGroupMemberList();
  },
  methods: {
    async getGroupMemberList() {
      let params = { ...this.pageMemberParams };
      const { status, data } = await this.$api.courseApi.getjionedgroupTeacher(
        params
      );
      if (status === "0") {
        this.isMoreMembers =
          this.pageMemberParams.page <
          Math.ceil(data.count / this.pageMemberParams.limit);
        this.memberList = data.rows;
      }
    },
    async loadMoreGroupMemberList() {
      if (this.isMoreMembers) {
        //是否更多
        let params = { ...this.pageMemberParams };
        const { status, data } =
          await this.$api.courseApi.getjionedgroupTeacher(params);
        if (status === "0") {
          this.isMoreMembers =
            this.pageMemberParams.page <
            Math.ceil(data.count / this.pageMemberParams.limit);
          this.memberList = this.memberList.concat(data.rows);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.groupfollower-box {
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
  .groupfollower-title1 {
    height: vh(25);
    font-size: vh(18);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #181d2c;
    line-height: vh(25);
  }
  .groupfollower-title2 {
    height: vh(60);
    font-size: vh(14);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #181d2c;
    line-height: vh(60);
  }
  .member-list-box {
    // width: vw(1013);
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    .member-content {
      max-width: 180px;
      min-width: 120px;
      padding-right: vw(38);
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 72px;
        height: 72px;
        border-radius: 50%;
      }
      .member-name {
        height: vh(30);
        line-height: vh(30);
        margin-top: 10px;
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #201002;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .member-course {
        height: vh(30);
        line-height: vh(30);
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        // font-weight: 600;
        color: #201002;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .view-more {
    margin: vw(40) 0;
    text-align: center;
    .el-button {
      width: vw(280);
      height: vw(40);
      background: #f48c06;
      border-radius: 32px;
      color: #ffffff;
      font-weight: 600;
      font-size: vw(16);
      border: none;
    }
  }
}
</style>